export default "/images/logo-7.png?b3fa7d4660c5ceb4e5e68e0079510802";